<template>
  <v-layout row v-if="isLoggedIn">
    <v-flex xs12 sm6 offset-sm3>
      <v-card v-if="isLoaded">
        <v-img
          :src="require('../assets/dummy.webp')"
          class="my-3"
          contain
          height="300"
        >
          <v-layout column fill-height>
            <v-layout>
              <v-flex xs6>
                <v-btn
                  class="ma-3 pt-1"
                  style="max-width: 150px"
                  color="primary"
                  @click="dialog2 = true"
                >
                  Change password
                </v-btn>
              </v-flex>
              
              <v-flex xs6 class="d-flex justify-end">
                <v-btn
                  class="ma-3 pt-1"
                  style="max-width: 110px"
                  color="primary"
                  @click="addMoney"
                >
                  Add Balance
                </v-btn>
              </v-flex>
              <v-flex xs6 class="d-flex justify-end">
                <v-btn
                  class="ma-3 pt-1"
                  color="primary"
                  @click="withdrawMoney"
                >
                  withdraw Balance
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- <div class="d-flex justify-end">
              <v-btn
                class="ma-3 pt-1"
                style="max-width: 150px"
                color="primary"
                @click="dialog2 = true"
              >
                Change password
              </v-btn>
            </div> -->
            <v-spacer></v-spacer>
            
            <v-card-title class="gray--text">
              <div class="display-1 pl-4">
                {{ indexData.balance.client_name }}
              </div>
              <v-spacer></v-spacer>
              <div class="display-1 mr-5">
                Client ID:{{ indexData.balance.id }}
              </div>
            </v-card-title>
            
          </v-layout>
        </v-img>

        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">phone</v-icon>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content class="ml-2">
              <v-list-tile-title>(650) 555-1234</v-list-tile-title>
              <v-list-tile-title>
                {{ indexData.balance.client_email }}
              </v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon v-if="indexData.balance.active == 1" color="indigo">
                radio_button_checked
              </v-icon>
              <v-icon v-else color="indigo">radio_button_unchecked</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title v-if="indexData.balance.active == 1">
                Active
              </v-list-tile-title>
              <v-list-tile-title v-else>Inactive</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">cake</v-icon>
              <v-icon color="indigo">location_city</v-icon>
            </v-list-tile-action>

            <v-list-tile-content class="ml-2">
              <v-list-tile-title>02/02/1996</v-list-tile-title>
              <v-list-tile-title>Khilkhet, Dhaka</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon color="indigo">person</v-icon>
              <v-icon color="indigo">wc</v-icon>
            </v-list-tile-action>

            <v-list-tile-content class="ml-2">
              <v-list-tile-title>Male</v-list-tile-title>
              <v-list-tile-title>Unmarried</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset class="mb-2"></v-divider>

          <v-list-tile>
            <v-list-tile-content>
              <v-card color="indigo" dark>
                <v-card-title>Total Added</v-card-title>
                <div class="text-xs-center mb-3">
                  {{ indexData.balance.total_added }}
                </div>
              </v-card>
            </v-list-tile-content>

            <v-list-tile-content>
              <v-card color="indigo" dark>
                <v-card-title>Total Balance</v-card-title>
                <div class="text-xs-center mb-3">
                  {{ indexData.balance.total_balance }}
                </div>
              </v-card>
            </v-list-tile-content>

            <v-list-tile-content>
              <v-card color="indigo" dark>
                <v-card-title>Available Balance</v-card-title>
                <div class="text-xs-center mb-3">
                  {{ indexData.balance.available_balance }}
                </div>
              </v-card>
            </v-list-tile-content>

            <v-list-tile-content>
              <v-card color="indigo" dark>
                <v-card-title>Holding Balance</v-card-title>
                <div class="text-xs-center mb-3">
                  {{ indexData.balance.holding_balance }}
                </div>
              </v-card>
            </v-list-tile-content>

            <!-- <v-list-tile-content>
              <v-card color="indigo" dark>
                <v-card-title>Total Withdrawn</v-card-title>
                <div class="text-xs-center mb-3">
                  {{ indexData.balance.total_withdrawn }}
                </div>
              </v-card>
            </v-list-tile-content> -->

            <v-list-tile-content>
              <v-card color="indigo" dark>
                <v-card-title>Total Cost</v-card-title>
                <div class="text-xs-center mb-3">
                  {{ indexData.balance.total_cost }}
                </div>
              </v-card>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
      <v-dialog v-model="resError" width="500">
        <v-card>
          <v-card-title class="headline red accent-3" primary-title>
            Warning Message
          </v-card-title>

          <v-card-text>
            {{ resErrorMsg }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red accent-3" flat @click="close">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-if="permissionError == 1" width="500">
        <v-card>
          <v-card-title class="headline red accent-3" primary-title>
            Warning Message
          </v-card-title>

          <v-card-text>
            {{ errorMsg }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red accent-3" flat @click="close">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <v-snackbar
          v-model="snackbar"
          :right="x === 'right'"
          :timeout="timeout"
          color="black"
          :top="y === 'top'"
        >
          {{ errorMsg }}
          <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div>
      <v-dialog v-model="dialog2" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Change Your Password</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="insertItem.old_password"
                    type="password"
                    label="Old Password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="insertItem.new_password"
                    type="password"
                    label="New Password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" @click="close">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="save">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Transaction Details</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          ID
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Trx ID
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.trans_id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Trx Status
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.transaction_status }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Payment Reason
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.payment_reason }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Amount
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          <span v-if="editedItem.debit_credit == 1">+</span>
                          <span v-else>-</span>
                          {{ editedItem.amount }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Trx Date
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.transaction_at }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" @click="close">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
        </template>
      </v-dialog>
      <v-divider inset class="mt-2"></v-divider>
      <v-list-tile-title class="title font-weight-bold text-sm-center">
        Transaction Details
      </v-list-tile-title>
      <v-data-table
        :headers="headers"
        :items="indexData.transactions"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.trans_id }}</td>
          <td v-if="props.item.debit_credit == 1">+{{ props.item.amount }}</td>
          <td v-else>-{{ props.item.amount }}</td>
          <td>{{ props.item.transaction_at }}</td>
          <td class="text-xs-center">{{ props.item.transaction_status }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" @click="viewItem(props.item)">
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  <v-layout v-else>
    <Signin class="mt-1"></Signin>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import Signin from "@/views/auth/Signin";
  import axios from "axios";
  import { ROOT_URL } from "@/api/connectingUrls";
  import router from "../router";
  export default {
    components: {
      Signin,
    },
    data: () => ({
      dialog: false,
      dialog2: false,
      resError: 0,
      resErrorMsg: "",
      permissionError: 0,
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 3000,
      apiUrl: "client-profile",
      headers: [
        {
          text: "ID",
          align: "left",
          class: "indigo text-weight-bold white--text",
          value: "title",
        },
        {
          text: "Trx ID",
          sortable: false,
          class: "indigo text-weight-bold white--text",
          value: "amount",
        },
        {
          text: "Amount",
          sortable: false,
          class: "indigo text-weight-bold white--text",
          value: "interest_amount",
        },
        {
          text: "Trx Date",
          class: "indigo text-weight-bold white--text",
          value: "rate",
        },
        {
          text: "Trx Status",
          sortable: false,
          align: "center",
          class: "indigo text-weight-bold white--text",
          value: "rate",
        },
        {
          text: "Actions",
          class: "indigo text-weight-bold white--text",
          value: "name",
          sortable: false,
        },
      ],
      editedItem: {},
      defaultItem: {},
      insertItem: {
        old_password: "",
        new_password: "",
      },
      defaultInsertItem: {
        old_password: "",
        new_password: "",
      },
    }),
    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.balance) {
          return true;
        } else {
          return false;
        }
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
        this.permissionError = this.error;
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      viewItem(item) {
        this.editedItem = Object.assign([], item);
        this.dialog = true;
      },

      close() {
        this.dialog = false;
        this.dialog2 = false;
        this.resError = 0;
        this.resErrorMsg = "";
        this.permissionError = 0;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.insertItem = Object.assign({}, this.defaultInsertItem);
        }, 300);
      },

      async save() {
        var popUpMsg = confirm(
          "Are you sure you want to change your password?"
        );
        if (popUpMsg) {
          try {
            const token = window.localStorage.getItem("datadash_token");
            if (token != null) {
              return axios
                .post(`${ROOT_URL}/${"update-password"}`, this.insertItem, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                })
                .then((response) => {
                  // console.log(response);
                  if (response.data.error == 0) {
                    this.errorMsg = response.data.errorMsg;
                    this.snackbar = true;
                    this.dialog2 = false;
                  } else {
                    this.resError = response.data.error;
                    this.resErrorMsg = response.data.errorMsg;
                  }
                });
            }
          } catch (error) {
            // console.log(error);
          }
        }
        this.close();
      },

      addMoney() {
        router.push("/client-payment-page");
      },

      withdrawMoney() {
        router.push("/client-balance-withdraw");
      },
    },
  };
</script>
